import { useRef } from 'react';
import styles from './FileInput.module.css';

const FileInput = ({
    onFileSelect,
    acceptedFileTypes,
    multiple = false,
    header,
    label = 'Choose File(s)',
    id,
    name,
    disabled = false
}) => {
    const fileInputRef = useRef(null);

    const handleChange = (event) => {
        const files = event.target.files;

        if (onFileSelect && files.length > 0) {
            onFileSelect(files);
        };
    };

    return (
        <div className={styles.fileListColumn}>
            <div className={styles.fileItem}>
                <div className={styles.previewWrapper} >
                    <i className={`fa-regular fa-file ${styles.preview}`} />
                </div>
                {window.innerWidth >= 500 &&<div
                    type='text'
                    value={''}
                    className={styles.fileNameInput}
                    aria-label={`Edit name for ${name}`}
                    disabled={true}
                >File name appears here on upload</div>}
                <div className={`${styles.fileInputContainer} ${disabled && styles.disabled}`}>
                    {header && <div className={styles.header} >{header}</div>}
                    {label && <label htmlFor={id} className={styles.fileLabel} >{label}</label>}
                    <input
                        type='file'
                        id={id}
                        name={name || id}
                        accept={acceptedFileTypes}
                        multiple={multiple}
                        onChange={handleChange}
                        ref={fileInputRef}
                        className={styles.fileInput}
                        style={{ display: 'block' }}
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    );
};

export default FileInput;
